const FOOD_AMIGOS_HOSTS = ['localhost', '127.0.0.1', '0.0.0.0'];

/**
 * FoodAmigos keeps its own hosts (`*.foodamigos.io`, plus local dev): a
 * logged-out visitor without a `?partner=` slug gets the FoodAmigos brand
 * there and the neutral brand everywhere else.
 */
export function isFoodAmigosHost(hostname) {
  const host = (hostname ?? '').toLowerCase();

  return FOOD_AMIGOS_HOSTS.includes(host) || host === 'foodamigos.io' || host.endsWith('.foodamigos.io');
}
